var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import styled from 'styled-components';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, MenuItem, TextField } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useFormContext } from '../FormContext';
const StyledDialog = styled(Dialog) `
  .action {
    margin-top: 12px;
  }
`;
export const FormConfigActionDialog = (_a) => {
    var { onCancel, onChange } = _a, props = __rest(_a, ["onCancel", "onChange"]);
    const { actionPlugins } = useFormContext();
    const [action, setAction] = useState(props.action);
    const plugin = action && actionPlugins.find(plugin => plugin.type === action.type);
    return (React.createElement(StyledDialog, Object.assign({ fullWidth: true }, props),
        React.createElement(DialogTitle, null, "Configure an Action"),
        React.createElement(DialogContent, null,
            React.createElement(DialogContentText, { gutterBottom: true }, "Perform an action when transitioning to this section."),
            React.createElement(TextField, { select: true, fullWidth: true, variant: 'outlined', size: 'small', label: 'Action Type', value: (action === null || action === void 0 ? void 0 : action.type) || '', onChange: event => {
                    const type = event.target.value;
                    setAction({ type });
                } },
                React.createElement(MenuItem, { selected: true, disabled: true }, "Select Condition Type"),
                actionPlugins.map(plugin => (React.createElement(MenuItem, { key: plugin.type, value: plugin.type }, plugin.type)))),
            (() => {
                if (!action || !action.type) {
                    return null;
                }
                if (!plugin) {
                    return (React.createElement(Alert, { severity: 'error' },
                        "Action \"",
                        action.type,
                        "\" plugin not found."));
                }
                return (React.createElement("div", { className: 'action' },
                    React.createElement(plugin.configurator, { action: action, onChange: action => {
                            setAction(Object.assign({}, action));
                        } })));
            })()),
        React.createElement(DialogActions, null,
            React.createElement(Button, { color: 'primary', onClick: () => onCancel === null || onCancel === void 0 ? void 0 : onCancel() }, "Cancel"),
            React.createElement(Button, { variant: 'contained', color: 'primary', disabled: Boolean(!action || !(plugin === null || plugin === void 0 ? void 0 : plugin.validate(action))), onClick: () => action && (onChange === null || onChange === void 0 ? void 0 : onChange(action)) }, "Save"))));
};
export default FormConfigActionDialog;
//# sourceMappingURL=FormConfigActionDialog.js.map